import React, { useState, useEffect, useId } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button, AlertMessage } from './SkepticParts';
import { stripe_checkout_session } from '../api/api_calls';



const CancelSubscriptionModal = ({api_server_url}) => {
    const uniqueId = useId();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [userEmail, setUserEmail] = useState('');
    const [userData, setUserData] = useState(null);
    const [tierData, setTierData] = useState(null);
    const [buttonState, setButtonState] = useState('default'); //State can be default, loading, disabled 
    const [alertMessage, setAlertMessage] = useState({visible:false, message:{}});

    const handleAlertVisibility = (shown) => {
        if(!shown){
          setAlertMessage({visible:false, message:{}});
        }
    }

    useEffect(() => {
        const handleOpenModal = (event) => {
            setIsModalOpen(true);

            if(event.detail.user_data?.client_email?.length === 0 || event.detail.user_data?.client_email === undefined){
                setButtonState('disabled');
                setAlertMessage({ visible:true, message:{type: 'danger', title: 'Error', text: `User's Email not set, we cannot continue!`, duration: 5000} });
            }

            setUserEmail(event.detail.user_data.client_email);
            setUserData(event.detail.user_data);
            setTierData(event.detail.tier_data);
        }

        window.addEventListener('openCancelSubscriptionModal', handleOpenModal);

        return () => {
          window.removeEventListener('openCancelSubscriptionModal', handleOpenModal);
        };
      }, []);

    const handleModalClose = () => {
        setIsModalOpen(false);
    };


    const stripe_cancel = async () => {
        console.log('[+] Stripe Cancel run!');
        setButtonState('loading');
        try {
            
            if(userEmail.length == 0) throw new Error('Email is missing!');
            //await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulate Stripe checkout

            const userDataWithUpdatedEmail = { ...userData, client_email: userEmail };
            const response = await stripe_checkout_session(api_server_url, 'cancel_subscription', tierData, userDataWithUpdatedEmail);

            if (response.message === 'ok') {
                setAlertMessage({
                    visible: true,
                    message: {
                      type: 'success',
                      title: 'Subscription Cancelled',
                      text: 'Your subscription has been scheduled for cancellation. You will continue to have access until the end of your current billing period.',
                      duration: 5000,
                    },
                });
                
                setTimeout(()=>{window.location.href='/'},3500);
                
            } else {
                setAlertMessage({ visible:true, message:{type: 'danger', title: 'Error', text: response.data, duration: 5000} });
                setButtonState('default');
            }

        } catch (error) {
            console.log('[x] err in stripe cancel -> ', error.message);
            setAlertMessage({ visible:true, message:{type: 'danger', title: 'Error', text: response.data, duration: 5000} });
            setButtonState('default');
        }
  }

    if (!isModalOpen) return null;

    const modalVariants = {
        hidden: { opacity: 0, translateY: "2.5rem", scale: 0.95 },
        visible: { opacity: 1, translateY: "0rem", scale: 1 },
        exit: { opacity: 0, translateY: "2.5rem", scale: 0.95 },
      };

    return(
        <>            
            <div onClick={handleModalClose} className={`${isModalOpen ? 'flex' : 'hidden'} skp_modal_wrapper`} role="dialog" aria-modal="true">
                <motion.div 
                variants={modalVariants}
                initial="hidden"
                animate="visible"
                exit="exit"
                transition={{
                  duration: 0.2,
                  ease: [0.4, 0, 0.2, 1],
                  delay: 0.075,
                }}
                className='skp_modal_window' onClick={(e) => e.stopPropagation()}>
                    
                    <motion.div whileHover={{ scale: 1.05, rotate: 12, backgroundColor: "#ff5f5f" }} onClick={handleModalClose} 
                      role="button" className='size-10 bg-skeptic-primary rounded-full absolute top-2 right-2 sm:-top-5 sm:-right-5'>
                          <svg className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2' width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                            <mask id={`mask_${uniqueId}`} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x={0} y={0} width={24} height={24}>
                              <rect width={24} height={24} fill="#D9D9D9" />
                            </mask>
                            <g mask={`url(#mask_${uniqueId})`}><path d="M6.4 19L5 17.6L10.6 12L5 6.4L6.4 5L12 10.6L17.6 5L19 6.4L13.4 12L19 17.6L17.6 19L12 13.4L6.4 19Z" fill="white"/></g>
                          </svg>
                    </motion.div>

                    <AlertMessage show={alertMessage.visible} message_body={alertMessage.message} handleAlertVisibility={handleAlertVisibility} />

                    <div className="flex flex-col justify-center items-center transition-all">
                        <div className="text-5xl">👀</div>
                        <h3 className="mt-8 font-bold text-[1.75rem] text-center text-skeptic-charcoal dark:text-skeptic-foreground-dark">Are you sure you want to leave?</h3>
                        <div className="flex gap-3 mt-8">
                            <Button 
                            text={'Cancel'} 
                            state={'default'} 
                            onClick={handleModalClose} />

                            <Button 
                            text={buttonState === 'loading' ? 'Loading' : 'Unsubscribe'} 
                            state={buttonState} 
                            onClick={stripe_cancel} />
                        </div>
                    </div>

 
                </motion.div>            
            </div>
        </>
    )
}

export default CancelSubscriptionModal; // Default export